module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.accountPermission))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d62a14d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPermissionsRow.vue
// module id = 533
// module chunks = 0